import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectListItems } from '../../../../../redux/library/selector';
import { templates } from '../../../../../redux/templates/action';
import { selectTemplatesListItems } from '../../../../../redux/templates/selector';
import { accountTypes } from '../../../../../redux/account-types/action';
import { accounts } from '../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { selectAccountTypesListItems } from '../../../../../redux/account-types/selector';
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { websites } from '../../../../../redux/websites/action';
import storePersist from '../../../../../redux/storePersist';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import PageLoader from '../../../../../components/PageLoader';
import ProgramComponent from '../components/template-groups.component';
import Popup from '../../../../../common/components/popup';
import ModalTemplateComponent from '../components/template-modal.component';
import { deepCopy } from '../../../../../common/services/common.service';
import { sectionTemplates } from '../../../../../redux/section-templates/action';
import { selectSectionTemplatesQueryItems } from '../../../../../redux/section-templates/selector';
import { ListCriteria } from '../../../types/list-criteria';




const ManagemenSectionTemplate = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [columnDefs, setColumnDefs] = useState({});
    const [selectedTemplate, setSelectTemplate] = useState<any>([])
    const [addItem, setAddItem] = useState<any>(undefined);
    const queryItems = useSelector(selectSectionTemplatesQueryItems)
    const [selectedTemplateValues, setSelectedTemplateValues] = useState([]);
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const libraryData = useSelector(selectListItems)
    const templateListis = useSelector(selectTemplatesListItems)
    var tenantId = storePersist?.get("accessTokenMetadata")?.current?.TokenMetadata?.TenantId;
    const params: any = useParams()
    const [accountTypesList, setAccountTypesList] = useState<any>([]);
    const [associatedAccountTypeId, setAssociatedAccountTypeId] = useState<number | undefined>();
    const [ownerLevelId, setOwnerLevelId] = useState<number | undefined>();
    const accountItems = useSelector(selectAccountsListItems)
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const [accountsList, setAccountsList] = useState<any>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const TypeData = libraryData?.result?.Type
    const [
        selectedTemplatedGroups,
        setSelectedTemplatedGroups
    ] = useState<any>([])

    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>([])

    const listAccountTypes = async () => {
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBAAccountTypes = async () => {
        // v6.1/organization/dbn/dba-type-dba-mappings
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBNBizAccountTypes = async () => {
        // v6.1/organization/dbn/biz-net-types
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listAccountsByType = async ({ searchCriteria, filterCriteria, dateCriteria }: ListCriteria) => {
        await dispatch(accounts.resetAction({ actionType: 'list' }))
        await dispatch(accounts.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
            entity: 'accounts',
            jsonData: {
                "Filters": filterCriteria,
                "Searches": searchCriteria,
                "DateCriteria": dateCriteria,
            }
        }))
    }

    const fetchQueryById = () => {
        dispatch(sectionTemplates.query({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/template-groups/query`, entity: 'sectionTemplates', jsonData: {
                Context: {},
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedTemplatedGroups({ ...selectedTemplatedGroups, [field]: event })
        setSelectTemplate({ ...selectedTemplate, [field]: event })
    }


    const getTemplateGroupItemTypeId = (TemplateGroupEntityType: number) => {
        const match = libraryData?.result?.TemplateGroupEntityType?.find((x: any) => x.Value === TemplateGroupEntityType);
        return match?.TemplateGroupItemTypeId || 0;
    };


    // media handle form change
    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value);
    }

    const getVehicleCategoryName = (Id: number) => {
        const result = _.find(templateListis?.result?.items, { Id: Number(Id) });
        return result?.Name || null;
    };




    useEffect(() => {


        dispatch(accountTypes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
            .then(() => {

                dispatch(templates.list({
                    url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates/list`,
                    entity: 'templates',
                    jsonData: {}
                }))
            })
            .then(() => {
                if (params?.id > 0) {
                    fetchQueryById()
                } else {

                    setIsLoading(false)
                }
            })
    }, []
    )
    useEffect(() => {
        if (isQuery) {
            const querydata: any = queryItems?.result?.items?.[0]; // first record ah eduthuko
            if (querydata) {
                setSelectedTemplatedGroups(querydata);

                const oneProgramItemsData: any = querydata?.TemplateGroupItems?.map((item: any) => {
                    return {
                        Id: item?.Id,
                        Name: item?.Name,
                        TemplateGroupItemTypeId: item?.TemplateGroupItemTypeId || 0,
                        EntityTypeId: item?.EntityTypeId || 0,
                        EntityTypeName: item?.EntityTypeName || "",
                        EntityId: item?.EntityId,
                        EntityName: getVehicleCategoryName(item?.EntityId),
                        IsActive: item?.IsActive,
                        StartDateUtc: item?.StartDateUtc,
                        EndDateUtc: item?.EndDateUtc,
                    };
                }) || [];

                setSelectedTemplateValues(oneProgramItemsData);
            }
        }
    }, [isQuery, queryItems]);




    const back = () => {
        navigate('/management/cms/template-groups')
    }



    //Save the modal data function
    const handleSaveItem = async (data: any) => {
        const newItem = {
            Id: data?.Id || 0,
            Name: data?.Name,
            TemplateGroupItemTypeId: data?.TemplateGroupEntityType || 0,
            EntityTypeId: data?.EntityTypeId || 0,
            EntityTypeName: data?.EntityTypeName || "",
            EntityId: data?.EntityId,
            EntityName: data?.EntityName || "",
            IsActive: data?.IsActive,
            StartDateUtc: data?.StartDateUtc,
            EndDateUtc: data?.EndDateUtc,
        };

        setSelectedTemplateValues((prevState: any) => {
            const exists =  prevState.some((item: any) => item.Name === newItem.Name);
            return exists
                ? prevState.map((item: any) => item.Name === newItem.Name ? newItem : item)
                : [...prevState, newItem];
        });
        closeModal();
    };


    // Add button
    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add Event Tickets</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAddItem(),
        }
    ];

    //Table ColumnDef Function
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Name', headerName: 'Name' },



        ]);
    }

    useEffect(() => {
        setAssociatedAccountTypeId(selectedTemplatedGroups?.OwnerTypeId);
        setOwnerLevelId(selectedTemplatedGroups?.OwnerLevelId);
    }, [selectedTemplatedGroups]);

    useEffect(() => {
        if (associatedAccountTypeId && accountTypesList) {
            const accountTypeName = accountTypesList?.find(
                (item: any) => item.Id === associatedAccountTypeId
            )?.Name;
            const accountTypeValue = TypeData.find(
                (type: any) => type.Text === accountTypeName
            )?.Text;
            if (accountTypeValue) {
                listAccountsByType({
                    filterCriteria: [{
                        "FieldName": "Type",
                        "FilterOperatorId": 6,
                        "FieldValue": accountTypeValue,
                        "FieldType": "text"
                    }]
                })
            }
        }
    }, [accountTypesList, associatedAccountTypeId]);



    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                listAccountTypes();
                break;
            case 11:
                listDBAAccountTypes();
                break;
            case 12:
                listDBNBizAccountTypes();
                break;
            default:
                dispatch(accountTypes.resetAction({ actionType: 'list' }))
                break;

        }
    }, [ownerLevelId]);

    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                setAccountTypesList(accountTypeItems?.result?.items);
                setAccountsList([]);
                break;
            case 11:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.Id, Name: o?.Name } }));
                setAccountsList([]);
                break;
            case 12:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.IEAccountTypeId, Name: o?.IEAccountTypeName } }));
                setAccountsList([]);
                break;
            default:
                setAccountTypesList([]);
                setAccountsList([]);
                break;

        }
    }, [accountTypeItems]);

    useEffect(() => {
        dispatch(accounts.resetAction({ actionType: 'list' }))
        setAccountsList([])
    }, []);

    useEffect(() => {
        setAccountsList(accountItems?.result?.items || [])
    }, [accountItems]);

    useEffect(() => {
        createColumnDefs();
    }, []);

    //Add the data in the Table Function
    const handleAddItem = () => {
        setAddItem({
            id: 0
        });
    }

    //Table Edit Function
    const handleEdit = (itemData: any) => {
        setAddItem({
            id: itemData.id
        })
        setSelectTemplate(itemData)

    }

    //Table Delete Function
    const handleDelete = (data: any) => {
        setSelectedTemplateValues((prevState: any) =>
            prevState.filter((item: any) => item?.Name !== data?.Name)
        );

    };

    //Modal Close Function
    const closeModal = () => {
        setAddItem(undefined)
        setSelectTemplate('')
    }

    // Modal Function
    const NewItemPopup = ({ handleSaveItem }: any) => {
        const [localItems, setLocalItems] = useState(deepCopy(selectedTemplate));
        const handleLocalFormChange = (value: any, field: any) => {
            setLocalItems((prev: any) => ({
                ...prev,
                [field]: value,
            }));
        };
        const handleItemSubmit = () => {
            setLocalItems(localItems);
            handleSaveItem(localItems)
        };
        return (
            <>
                <Popup onClose={closeModal}>
                    <ModalTemplateComponent
                        Close={closeModal}
                        handleItemSubmit={handleItemSubmit}
                        selectedTemplate={localItems}
                        onInnerBasicFormChange={handleLocalFormChange}
                        templates={templateListis?.result?.items}
                        TemplateGroupEntityType={libraryData?.result?.TemplateGroupEntityType}


                    />

                </Popup>
            </>
        )
    }
    // Submit the events Function
    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )

        const EventTicketsItemsData: any = selectedTemplateValues?.map((item: any) => {
            const itemData = {
                Id: item?.Id || 0,
                Name: item?.Name,
                TemplateGroupItemTypeId: item?.TemplateGroupItemTypeId,
                EntityTypeId: item?.EntityTypeId || 0,
                EntityTypeName: item?.EntityTypeName || "",
                EntityId: item?.EntityId,
                EntityName: getVehicleCategoryName(item?.EntityId),
                IsActive: item?.IsActive,
                StartDateUtc: item?.StartDateUtc,
                EndDateUtc: item?.EndDateUtc,
                MediaMappings: {
                    MediaFiles: [],
                    Templates: []
                }


            }
            return itemData
        })
        const eventData = {


            "Id": selectedTemplatedGroups?.Id || 0,
            "IsActive": selectedTemplatedGroups?.IsActive || false,
            "Name": selectedTemplatedGroups?.Name,
            "Remarks": selectedTemplatedGroups?.Remarks,
            "Description": selectedTemplatedGroups?.Description,
            "OwnerLevelId": selectedTemplatedGroups?.OwnerLevelId || 0,
            "OwnerTypeId": selectedTemplatedGroups?.OwnerTypeId || 0,
            "OwnerAccountId": selectedTemplatedGroups?.OwnerAccountId || 0,
            "StartDateUtc": selectedTemplatedGroups?.StartDateUtc,
            "EndDateUtc": selectedTemplatedGroups?.EndDateUtc,
            "DisplayOrder": Number(selectedTemplatedGroups?.DisplayOrder),

            "TemplateGroupItems": EventTicketsItemsData,
            "LimitedToOrganizationUnitIds": [
                0
            ]

        }
        if (parmas?.id > 0) {
            await dispatch(templates.resetAction({ actionType: 'update' }))
            await dispatch(templates.update({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/template-groups`, entity: 'templates', jsonData: {
                    Context: {},
                    Records: [
                        eventData
                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(templates.resetAction({ actionType: 'create' }))
            await dispatch(templates.create({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/template-groups`, entity: 'templates', jsonData: {

                    Context: {},
                    Records: [
                        eventData
                    ]

                }
            })).then(() => {
                back()
            })

        }

    }



    return (
        <>

            {
                addItem ? <NewItemPopup handleSaveItem={handleSaveItem} /> : <></>
            }
            {isLoading ? <PageLoader /> :


                <ProgramComponent
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    selectedTemplatedGroups={selectedTemplatedGroups}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    onFormItemChange={handleFormMediaItemChange}
                    id={parmas?.id}
                    selectedTemplateValues={selectedTemplateValues}
                    columnDefs={columnDefs}
                    handleEdit={handleEdit}
                    additionButtons={additionButtons}
                    handleDelete={handleDelete}
                    PolicyOwnerType={libraryData?.result?.PolicyOwnerType}
                    accountTypesListLoading={accountTypeItems?.isLoading}
                    accountTypesList={accountTypesList}
                    accountListLoading={accountItems?.isLoading}
                    accountsList={accountsList}
                    isLoading={isLoading}


                />
            }

        </>
    )


}


export default ManagemenSectionTemplate;